import { sendGoogleEvent, sendRequest } from '@html/_common/utils';

const ENDPOINT = '/api/operator/reviews';
const BASE = 'ao-clp-operator-reviews';

const REVIEWS_BLOCK_SELECTOR = `.js-${BASE}`;
const REVIEWS_LOAD_MORE_SELECTOR = `.js-${BASE}__load-more`;
const REVIEWS_LIST_SELECTOR = `.js-${BASE}__list`;
const REVIEW_SHOW_MORE_SELECTOR = `.js-${BASE}__review-show-more`;
const REVIEW_ITEM_BODY_SELECTOR = `.js-${BASE}__review-item-body`;

const DETAILS_SELECTOR = `.js-${BASE}__stats--details`;
const DETAILS_TRIGGER_SELECTOR = `.js-${BASE}__details-trigger`;

const eventCategory = 'Operator CLP - Reviews';

export default function AOClpOperatorReviews() {
  const $reviewsBlock = $(REVIEWS_BLOCK_SELECTOR);

  const operatorId = $reviewsBlock.data('operatorId');
  const tourId = $reviewsBlock.data('tourId') || 0;

  const initTracking = () => {
    $reviewsBlock.find('[data-action]').each((index, element) => {
      $(element).on('click', () => {
        sendGoogleEvent(
          eventCategory,
          $(element).data('action'),
          $(element).data('label'),
        );
      });
    });
  };

  const initShowMore = () => {
    $reviewsBlock.on('click', REVIEW_SHOW_MORE_SELECTOR, (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget);
      const $reviewBody = $target.prev(REVIEW_ITEM_BODY_SELECTOR);

      const reviewId = Number($target.data('label'));

      if (!reviewId) {
        return;
      }
      sendRequest(ENDPOINT, {
        reviewId,
        token: window.csrf,
      }, (data) => {
        if (!data.success) {
          return;
        }
        $reviewBody.text(data.review.comments);
        $target.remove();
      });
    });
  };

  const initStatsDetails = () => {
    const hideMobClass = `${BASE}__hide-mob`;

    $(DETAILS_TRIGGER_SELECTOR).on('click', (e) => {
      e.preventDefault();
      const $trigger = $(e.currentTarget);
      const $detals = $trigger.siblings(DETAILS_SELECTOR);

      const triggerText = $trigger.data($detals.hasClass(hideMobClass) ? 'hideText' : 'showText');

      $detals.toggleClass(hideMobClass);

      $trigger.text(triggerText);
      $trigger.toggleClass(`${BASE}__details-trigger--collapsed`);
    });
  };

  const initLoadMoreReviews = () => {
    $(REVIEWS_LOAD_MORE_SELECTOR).on('click', (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);

      $btn.attr('disabled', true);
      const page = Number($btn.data('page')) || 2;
      const perPage = Number($btn.data('perPage'));

      sendRequest(ENDPOINT, {
        operatorId,
        tourId,
        page,
        perPage,
        token: window.csrf,
      }, (data) => {
        if (!data.success) {
          return;
        }
        $(REVIEWS_LIST_SELECTOR).append(data.component);

        if ((page - 1 * perPage + data.count) >= Number($btn.data('total'))) {
          $btn.remove();
        } else {
          $btn.data('page', page + 1);
          $btn.removeAttr('disabled');
        }
      });
    });
  };

  const initiate = () => {
    if ($reviewsBlock.length) {
      initTracking();
      initStatsDetails();
      initShowMore();
      initLoadMoreReviews();
    }
  };

  return { initiate };
}
